import { useState } from "react";
import HumbeeModal from "../../../v2/MUI_custom_component/Modal/HumbeeModal";
import DataLostSvg from "../../Illustrration/components/DataLostSvg";

import { deleteAccountAction } from "./API/Action/index";
import { toast } from "react-toastify";
import { deleteRegisterNotificationToken } from "../../../screen/distributor/action/util_action";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export const DeleteAccount = ({ open, onClose, deleteAccountModalInfo }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { showWarning, headerText, subHeaderText } =
    deleteAccountModalInfo || {};

  const deleteAccount = async () => {
    setLoading(true);
    const userToken = JSON.parse(localStorage.getItem("message_token"));
    await deleteRegisterNotificationToken(userToken);
    const { error, message } = await deleteAccountAction();
    setLoading(false);

    if (!error) {
      localStorage.clear();
      dispatch({ type: "LOGOUT" });
      navigate("/login");
    } else {
      toast.error(message || "Something went wrong");
    }
  };

  return (
    <HumbeeModal
      open={open}
      onClose={onClose}
      onConfirm={showWarning ? null : deleteAccount}
      loading={loading}
      title={headerText}
      subtitle={subHeaderText}
      hideConfirmLabel={showWarning}
      cancelLabel={showWarning ? "Okay" : "No"}
      textButton={showWarning}
      illustration={<DataLostSvg />}
    />
  );
};
